module.exports = __webpack_public_path__ + "img/prize-05.994b1d5f.png";